import Form from "Clutch/Atoms/Form";
import { Calculate } from "./logic";
import { useState, useEffect } from "react";
import { Default, Selected } from 'Clutch/Molecules/Button/Variants/OptionButtons'
import Typography from "Clutch/Atoms/Typography";
import Button from "Clutch/Molecules/Button";
import ContextualError from "../common/contextualError";
import FormGroup from "../common/formGroup";

const MmInchesConversion = () => {

    const [inputValue, setInputValue] = useState("");
    const [isMetric, setIsMetric] = useState(false);
    const [result, setResult] = useState({
        isValid: false,
        errors: [],
        result: null,
    });

    useEffect(() => {
        if (inputValue != null) {
            setInputValue("");
            setResult({
                isValid: false,
                errors: [],
                result: null,
            });
        }
    }, [isMetric]);

    const CalculateInternal = (e) => {
        e.preventDefault()
        const r = Calculate({ inputValue, isMetric });
        setResult(r)
    }

    let InchesButton = isMetric ? Default : Selected
    let MillimetersButton = isMetric ? Selected : Default

    const inputValueError = result.errors.find(x => x.id == 'inputValue');
    return <Form onSubmit={CalculateInternal}>
        <FormGroup>
            <Typography><h4>Convert from:</h4></Typography>
            <InchesButton
                value={!isMetric ? { displayName: 'Inches' } : {
                    displayName: 'Inches'
                }}
                brand={'primary'}
                size={5}
                onClick={() => setIsMetric(false)} />
            <MillimetersButton
                value={isMetric ? { displayName: 'Millimeters' } : {
                    displayName: 'Millimeters'
                }}
                brand={'primary'}
                size={5}
                onClick={() => setIsMetric(true)}
            />
            <br /> <br />
            <Form.Textbox
                fill
                id={'inputValue'}
                label={`Input (${!isMetric ? "inches" : "millimeters"})`}
                intent={inputValueError ? 'negative' : null}
                value={inputValue}
                onChange={(e) => { setInputValue(e.target.value) }}
                type={'number'}
                placeholder={0}
                step="any"
            />
            <ContextualError error={inputValueError} />
        </FormGroup>
        <FormGroup>
            <Button intent={'action'} size={'small'} event={{}} text={`Convert to ${isMetric ? "inches" : "millimeters"}`}></Button>
        </FormGroup>

        <FormGroup>
            {result.isValid ? <Typography as={'span'} size={1.25} font={'bold'}>{result.result}</Typography> : false}
        </FormGroup>
    </Form>
}

export default MmInchesConversion